import styled from 'styled-components';
import { Paragraph } from '@pb/shared/ui/atoms/paragraph';
import { Label } from '@pb/shared/ui/atoms/label';

export const StyledFormElementContainer = styled.div`
    margin: 1.5rem 0;
`;

export const StyledInputContainer = styled.div`
    margin-top: 0.5rem;
`;
export const StyledLabel = styled(Label)`
    margin: 0;
`;

export const StyledHelperText = styled(Paragraph)`
    margin: 0;
    color: ${({ theme }) => theme.color.grey6};
`;

export const StyledValidationNotificationContainer = styled.div`
    margin-top: 0;
`;
